interface Grecaptcha {
  ready(callback: () => void): void;
  execute(siteKey: string, options: { action?: string }): Promise<string>;
}

declare global {
  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

const POLL_INTERVAL_MS = 100;

function loadedGrecaptcha(): Promise<Grecaptcha> {
  return new Promise((resolve) => {
    const poll = () => {
      const { grecaptcha } = window;
      if (grecaptcha) grecaptcha.ready(() => resolve(grecaptcha));
      else setTimeout(poll, POLL_INTERVAL_MS);
    };
    poll();
  });
}

function bindRecaptchaV3(input: HTMLInputElement) {
  const { form } = input;
  const { sitekey: siteKey, action } = input.dataset;
  if (!form || !siteKey) return;

  // Intercept from the start so early submissions still wait for a token
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const grecaptcha = await loadedGrecaptcha();
    input.value = await grecaptcha.execute(siteKey, action ? { action } : {});
    form.submit();
  });
}

document.querySelectorAll<HTMLInputElement>('input.g-recaptcha[data-sitekey]').forEach(bindRecaptchaV3);

export {};
